import { render, staticRenderFns } from "./InfoCardTabReadOnly.vue?vue&type=template&id=2da0cfa8&"
import script from "./InfoCardTabReadOnly.vue?vue&type=script&lang=js&"
export * from "./InfoCardTabReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports